import React, { useEffect, useState } from 'react';
import { element } from 'prop-types';
import { AuthContext } from './auth';

const BE_TOKEN_COOKIE_NAME = 'dd-be-token';

/**
 * Lê o token do cookie (definido pelo backend no redirect).
 */
const getTokenFromCookie = () => {
  const match = document.cookie.match(new RegExp(`${BE_TOKEN_COOKIE_NAME}=([^;]+)`));
  return match ? decodeURIComponent(match[1].trim()) : null;
};

/**
 * Remove o cookie do token.
 */
const clearTokenCookie = () => {
  document.cookie = `${BE_TOKEN_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

/**
 * Redireciona para o logout do Keycloak para encerrar a sessão SSO.
 */
const redirectToKeycloakLogout = () => {
  try {
    const creds = JSON.parse(process.env.REACT_APP_PORTAL_URL || '{}');
    const baseUrl = creds['auth-server-url']?.replace(/\/$/, '');
    const realm = creds.realm;
    const clientId = creds.resource;
    if (baseUrl && realm && clientId) {
      const redirectUri = encodeURIComponent(window.location.origin);
      window.location.href = `${baseUrl}/realms/${realm}/protocol/openid-connect/logout?client_id=${clientId}&post_logout_redirect_uri=${redirectUri}`;
      return true;
    }
  } catch (e) {
    console.warn('[BeAuth] Não foi possível redirecionar para logout Keycloak:', e);
  }
  return false;
};

/**
 * Provider de autenticação para o fluxo Becompliance → RiskCheck.
 * Token lido do cookie (definido pelo backend no redirect).
 * Axios continua enviando Authorization: Bearer no header.
 */
export const BeAuthProvider = ({ children }) => {
  const [token, setToken] = useState(getTokenFromCookie);

  useEffect(() => {
    setToken(getTokenFromCookie());
  }, []);

  const logout = () => {
    clearTokenCookie();
    localStorage.removeItem('dd-token');
    setToken(null);
    if (!redirectToKeycloakLogout()) {
      window.location.reload();
    }
  };

  const resolvedToken = token || getTokenFromCookie();

  const values = {
    token: resolvedToken,
    isAuthenticated: !!resolvedToken,
    logout,
    login: () => {}, // Não utilizado no fluxo Becompliance
  };

  return (
    <AuthContext.Provider value={values}>
      {children}
    </AuthContext.Provider>
  );
};

BeAuthProvider.propTypes = {
  children: element.isRequired,
};
